export const osnBackAndForthArrowsIcon = {
  data: `<svg viewBox="0 0 13 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M4.00635 7.5L1.00635 10.5L4.00635 13.5M11.5063 10.5H1.00635M8.50635 1L11.5063 4L8.50635 7M1.00635 4H11.5063" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'back-and-forth-arrows',
};
